import { useState } from "react";
import "./aufaSumData.css";
import ProjectSelectContiner from "../../docket/main/aufa/AufaProjects/ProjectSelectContiner";
import { fetchGetAufa } from "../../../faetures/fetch";
import ContinerData from "./ContinerData";


function AppAufaSumData({setDataForFilterFlights}) {
    const [project, setProject] = useState({flight: true, open: false, name: ''});
    const [data, setData] = useState({});

    const clickProject = (name) => {
        setProject({...project, name: name});

        fetchGetAufa(`start-flight?project=${name}`).then((resolve) => {
            if (typeof resolve === 'object' && resolve !== null && 'flights' in resolve && 'cars' in resolve) {
                setData(resolve);
                setProject({...project, open: true, name: name});
            }
        })
    }

    const clickData = (name) => {
        setDataForFilterFlights({name: name, project: project.name, flight: project.flight});
    }

    return (
        <div className={"aufaSumData"}>
            <div className={"aufaSumDataHead"}>
                <p 
                onClick={() => setProject({...project, flight: true})}
                style={{'color': project.flight ? 'rgb(0, 77, 105)' : 'black'}}
                >טיסות</p>

                <p 
                onClick={() => setProject({...project, flight: false})}
                style={{'color': project.flight ? 'black' : 'rgb(0, 77, 105)'}}
                >נסיעות פנים</p>
            </div>

            {
                project.open ?
                <ContinerData 
                data={project.flight ? data["flights"] : data["cars"]}
                setClose={() => setProject({...project, open: false})}
                onDClick={clickData}
                />
                :
                <ProjectSelectContiner
                flight={project.flight}
                setClose={false}
                onClick={clickProject}
            />

            }
        </div>
    )
}


export default AppAufaSumData;